<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "FilterFragments",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      },{
        name: 'phone',
        placeholder: '手机号',
        type: 'input'
      }],
      permission: {
        add: 'filterFragments:add',
        update: 'filterFragments:update',
        delete: 'filterFragments:delete',
        deleteBatch: 'filterFragments:deleteBatch'
      },
      url: {
        get: '/filterFragments/listByCondition',
        add: '/filterFragments/add',
        update: '/filterFragments/update',
        delete: '/filterFragments/delete/',
        delete_batch: '/filterFragments/deleteBatch',
        status: '/filterFragments/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      }, {
        field: 'phone',
        label: '用户',
        show: true,
        width: '',
      }, {
        field: 'fragments',
        label: '过滤片段',
        show: false,
        detail: true,
        width: '',
      }, {
        field: 'content',
        label: '请求返回结果',
        show: false,
        detail: true,
        width: '',
      }, {
          field: 'filterFragments',
          label: '过滤结果',
          detail: true,
          show: true,
          width: '',
        },  {
          field: 'status',
          label: '状态',
          show: {
            type: 'tag',
            tags: [{
              key: 0,
              value: '失败',
              type: 'danger'
            }, {
              key: 1,
              value: '进行中',
              type: 'warning'
            }, {
              key: 2,
              value: '成功',
              type: 'success'
            }]
          },
          width: '',
        }, {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }],
      operate: [],
      formFields: {
        addTitle: '直播片段',
        updateTitle: '直播片段',
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: false,
          filterable: true,
        },{
          field: 'userId',
          label: '用户',
          type: 'select',
          selectUrl: '/userInfo/getAllInfo',
          selectData: [],
          placeholder: '手机号',
          rules: [{message: '请输入手机号', trigger: 'blur', required: true}],
          add: true,
          update: false,
          filterable: true,
        }, {
          field: 'fragments',
          label: '过滤片段',
          type: 'input',
          placeholder: '过滤片段',
          rules: [{message: '请输入直过滤片段', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }],
      }
    }
  }
}
</script>

<style scoped>

</style>
